import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

// hospitality signups POS survey
// spreadsheet url: https://docs.google.com/spreadsheets/d/1ky-ca_ZkfVoAYITPFFdTnJX5iCf38Free0wKA42SS9w
const FORM_URL =
  'https://script.google.com/macros/s/AKfycbzeBr21M3HP1p28ckbrnupmRb61Pe10ghpI86Sy2WLDfUshNK5o9YA6h8JSW0bo-DCe/exec';

type FormData = {
  org_id: string;
  org_name: string;
  industry: string;
  org_size: string;
  pos: string;
  pos_other: string;
  integration_status?: string;
  loc_guid?: string;
  loc_name?: string;
  admin: string;
  email: string;
};

type PosData = {
  pos: string;
  user: AuthUserType;
  employeesCount: string;
  posOther?: string;
};

export async function sendPosFeedback(posData: PosData): Promise<void> {
  const data = getFormData(posData);

  if (!__DEV__) {
    fetch(`${FORM_URL}?${new URLSearchParams(data)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }
}

function getFormData(posData: PosData): FormData {
  const { pos, posOther, user, employeesCount } = posData;

  return {
    org_id: `${user.org.id}`,
    org_name: user.org.name,
    industry: user.org.businessCategory,
    org_size: employeesCount,
    pos,
    pos_other: posOther || '',
    admin: user.fullname,
    email: user.email,
    //TODO - for v2 - integration data
    integration_status: '',
    loc_guid: '',
    loc_name: '',
  };
}
